import { useCallback, useEffect, useState } from "react";
import { fetchWorkshops } from "../services/maintenanceService";
import type { Workshop } from "../types";

// Talleres configurados de la compañía (modo propio/externo, foto, bahías).
export function useWorkshops() {
  const [workshops, setWorkshops] = useState<Workshop[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      setWorkshops(await fetchWorkshops());
    } catch {
      setWorkshops([]);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { workshops, loading, error, reload };
}
